const COLORS = {
    PINK_INTELCIA: '#EA297C',
    GRAY: '#6E7191',
    WHITE: '#FFFFFF',
    WHITE_BLUE: '#F7F7FC',
    GRAY_BG: '#EFF0F6',
    BLACK_TEXT: '#14142B',
    GRAY_ICONS: '#4E4B66',
    GRAY_HOVER: '#D9DBE9',
    ORANGE_LINEAR: '#FC6767',
    GRAY_SUBTITLE: "#344054",
    PINK_OPACITY: "#FEF4F8",
    PINK_OPACITY2: "#FDE6EF",
    GRAY_AVATAR: "#E8E9F2",
    PINK_OPACITY3: "#FDEAF2",
    GRAY_BORDER: "#e0e0e0",
    BLACK_TEXT_TABLE: "#272833",
    GRA_ARROW: "#C4C4C4"
}

export { COLORS };
